import Stars from "./Stars/Stars";

const CourseRating = ({ avgRating, reviewCount }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 4,
      }}
    >
      <Stars fillCount={parseFloat(Number(avgRating).toFixed(1))} />
      <p style={{ fontWeight: "bold" }}>{`(${reviewCount})`}</p>
    </div>
  );
};

export default CourseRating;
